var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LanguageSelector_1;
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { commonCssStyles } from "../../global-styles.js";
import "../language-selector-menu/LanguageSelectorMenu.js";
import "../language-selector-link/LanguageSelectorLink.js";
import { classMap } from "lit/directives/class-map.js";
import { msg } from "@lit/localize";
import { AbstractDropdown } from "../dropdown-menu-mixin/AbstractDropdown.js";
let LanguageSelector = LanguageSelector_1 = class LanguageSelector extends AbstractDropdown(LitElement) {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    selectedLanguageDisplayName() {
        return this.options.find((option) => option.languageTag === this.selectedLanguageTag)?.displayName;
    }
    _selectLanguageFn(languageTag) {
        return (event) => {
            const selectedLanguage = new CustomEvent(LanguageSelector_1.SELECTED_LANGUAGE, {
                detail: { languageTag },
                bubbles: true,
                composed: true,
            });
            this.dispatchEvent(selectedLanguage);
            this.toggleDropdown(event);
        };
    }
    get dropdownContainerElement() {
        return this.shadowRoot.getElementById("menu");
    }
    focusMenuButton() {
        this.shadowRoot.querySelector(".selector-button").focus();
    }
    focusFirstDropdownItem() {
        this.shadowRoot.querySelector(".link").focus();
    }
    render() {
        return html ` <style>
        /*https://lit.dev/docs/components/styles/#styles-in-the-template*/
        .menu-item:first-child .link::part(linkcontainer):focus-visible {
          border-radius: 8px 8px 0 0;
        }

        .menu-item:last-child .link::part(linkcontainer):focus-visible {
          border-radius: 0 0 8px 8px;
        }
      </style>
      <div
        class="container ${classMap({
            open: this.open,
        })}"
      >
        <button
          class="selector-button"
          type="button"
          @click="${this.toggleDropdown}"
          role="combobox"
          aria-haspopup="listbox"
          aria-label="${msg("Select language")}"
          aria-controls="menu"
          aria-expanded="${this.open}"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            class="globe"
          >
            <path
              d="M15.9664 7.57895C15.916 6.53477 15.6471 5.54105 15.2269 4.63158C15.0924 4.34529 14.9412 4.05893 14.7731 3.78947C13.3781 1.51579 10.8572 0 8 0C5.14285 0 2.62183 1.51579 1.21006 3.78947C1.04199 4.05893 0.89072 4.34529 0.756308 4.63158C0.336138 5.54107 0.0840367 6.53474 0.0167956 7.57895C0.0167956 7.71371 0 7.86524 0 8C0 8.13476 2.17048e-08 8.28629 0.0167956 8.42105C0.0840339 9.46524 0.336138 10.4589 0.756308 11.3684C0.890784 11.6547 1.04199 11.9411 1.21006 12.2105C2.62183 14.4842 5.14285 16 8 16C10.8572 16 13.3782 14.4842 14.7899 12.2105C14.958 11.9411 15.1093 11.6547 15.2437 11.3684C15.6639 10.4589 15.916 9.46526 15.9832 8.42105C15.9832 8.28629 16 8.13476 16 8C16 7.86524 15.9832 7.71371 15.9664 7.57895H15.9664ZM2.23526 12.2105H4.42014C4.75628 13.2547 5.21003 14.1474 5.76469 14.7874C4.3193 14.3158 3.09241 13.4063 2.23526 12.2105ZM13.7647 3.78947H11.5798C11.2437 2.74529 10.7899 1.85263 10.2353 1.21263C11.6807 1.68424 12.9076 2.59371 13.7647 3.78947ZM11.3613 7.57895H8.42016V4.63158H10.9412C11.1765 5.52424 11.3278 6.51789 11.3613 7.57895ZM10.958 11.3684H8.43695V8.42105H11.3613C11.3277 9.48213 11.1765 10.4758 10.958 11.3684H10.958ZM4.65542 8.42105H7.5798V11.3684H5.05879C4.82348 10.4758 4.6722 9.48211 4.65541 8.42105H4.65542ZM5.04201 4.63158H7.56302V7.57895H4.65545C4.67225 6.51787 4.82352 5.52421 5.04204 4.63158H5.04201ZM10.6891 3.78947H8.42017V0.909474C9.34454 1.16211 10.1513 2.25684 10.6891 3.78947ZM7.57983 0.909474V3.78947H5.31092C5.84871 2.25684 6.65546 1.16211 7.57983 0.909474ZM5.31092 12.2105H7.57983V15.0905C6.65546 14.8379 5.84873 13.7432 5.31092 12.2105ZM8.42017 15.0905V12.2105H10.6891C10.1513 13.7432 9.34454 14.8379 8.42017 15.0905ZM5.74789 1.21263C5.19324 1.86949 4.73949 2.74526 4.40335 3.78947H2.21847C3.09245 2.5937 4.31932 1.68421 5.74789 1.21263ZM4.16806 4.63158C3.9664 5.52424 3.83192 6.51789 3.79833 7.57895H0.873955C0.941194 6.51787 1.22688 5.52421 1.6975 4.63158H4.16806ZM3.79833 8.42105C3.83193 9.48213 3.94961 10.4589 4.16806 11.3684H1.69746C1.22684 10.4758 0.941154 9.48211 0.873913 8.42105H3.79833ZM10.2521 14.7874C10.8068 14.1305 11.2605 13.2547 11.5967 12.2105H13.7816C12.9076 13.4063 11.6807 14.3158 10.2521 14.7874ZM11.832 11.3684C12.0505 10.4758 12.1849 9.48211 12.2017 8.42105H15.1261C15.0588 9.48213 14.7731 10.4758 14.3025 11.3684H11.832ZM12.2017 7.57895C12.1681 6.51787 12.0336 5.52421 11.832 4.63158H14.3026C14.7732 5.52424 15.0757 6.51789 15.1261 7.57895H12.2017Z"
            />
          </svg>
          <div class="selected-language text-body-s-regular">
            ${this.selectedLanguageDisplayName()}
          </div>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            class="chevron"
          >
            <path
              d="M7.30469 4.30469C7.67969 3.89844 8.33594 3.89844 8.71094 4.30469L14.7109 10.3047C15.1172 10.6797 15.1172 11.3359 14.7109 11.7109C14.3359 12.1172 13.6797 12.1172 13.3047 11.7109L8.02344 6.42969L2.71094 11.7109C2.33594 12.1172 1.67969 12.1172 1.30469 11.7109C0.898438 11.3359 0.898438 10.6797 1.30469 10.3047L7.30469 4.30469Z"
            />
          </svg>
        </button>
        <div
          class="dropdown-visible-container ${classMap({ hide: !this.open })}"
        >
          <language-selector-menu
            class="menu ${classMap({ hide: !this.open })}"
            id="menu"
            role="listbox"
          >
            ${repeat(this.options, (option) => option.languageTag, ({ languageTag, displayName }) => html ` <li class="menu-item">
                  <language-selector-link
                    displayName=${displayName}
                    ?selected=${languageTag == this.selectedLanguageTag}
                    @click="${this._selectLanguageFn(languageTag)}"
                    class="link"
                  >
                  </language-selector-link>
                </li>`)}
          </language-selector-menu>
        </div>
      </div>`;
    }
};
/**
 * The name identifying the type of the event that fires when the
 * selected language changes.
 */
LanguageSelector.SELECTED_LANGUAGE = "SELECTED_LANGUAGE";
// noinspection CssUnresolvedCustomProperty
LanguageSelector.styles = [
    commonCssStyles,
    css `
      .container {
        position: relative;
        width: fit-content;
      }

      .selector-button {
        background: none;
        color: inherit;
        border-radius: 4px;
        border: none;
        outline: inherit;
        display: flex;
        min-width: 133px;
        padding: var(--spacing-2xs) 0;
        align-items: center;
        gap: var(--spacing-xs);
        flex-shrink: 0;
        position: relative;
      }

      .selector-button:hover {
        cursor: pointer;
      }

      .selector-button .globe {
        fill: var(--text-text-weak-color);
        flex-shrink: 0;
      }

      .selector-button .selected-language {
        color: var(--text-text-weak-color);
      }

      .selector-button .chevron {
        fill: var(--text-text-color);
        transform: rotate(180deg);
        transition: var(--delay-transition75);
        flex-shrink: 0;
      }

      /* a mask to only show the dropdown menu below the button */
      .dropdown-visible-container {
        visibility: hidden;
        position: absolute;
        left: -8px;
        overflow: hidden;
      }

      .menu {
        width: max-content;
        position: relative;
        visibility: visible;
        display: flex;
        margin: 8px;
        transform: translateY(-4px);
        transition: var(--dropdown-transition);
      }

      .menu.hide {
        transform: translateY(-100%);
        visibility: hidden;
        opacity: 0;
      }

      .menu-item {
        display: flex;
        width: 100%;
      }

      .link {
        align-self: stretch;
        width: 100%;
      }

      .container.open .selector-button .chevron {
        transform: rotate(0deg);
      }

      .selector-button:focus-visible {
        outline: 2px solid var(--tones-lavender50-color);
      }

      @media (min-width: 1200px) {
        .dropdown-visible-container {
          left: initial;
          right: -8px;
        }
      }
    `,
];
__decorate([
    property({ type: Array })
], LanguageSelector.prototype, "options", void 0);
__decorate([
    property()
], LanguageSelector.prototype, "selectedLanguageTag", void 0);
LanguageSelector = LanguageSelector_1 = __decorate([
    customElement("language-selector")
], LanguageSelector);
export { LanguageSelector };
